export const lang = {
    // 菜单icon数组
    menu: [
      {
        name: 1,
        url: 'iconyezhuAPPfuwu'
      },
      {
        name: 2,
        url: 'icongongsiguanli'
      },
      {
        name: 3,
        url: 'iconqita'
      },
      {
        name: 4,
        url: 'iconshangpinguanli'
      },
      {
        name: 5,
        url: 'iconxiaoqufuwu'
      },
      {
        name: 6,
        url: 'iconxiaoquguanli'
      },
      {
        name: 7,
        url: 'iconguanggaoguanli'
      },
      {
        name: 8,
        url: 'iconwuyeguanli'
      }
    ],
    // headTop
    lab_textText: '试卷',
    lab_seeBlock: '看板',
    lab_help: '帮助',
    lab_message: '个人信息',
    lab_primaryColor: '主题色',
    lab_zhCn: '中英文',
    lab_sysSetting: '系统设定',
    lab_exit: '退出',
    lab_userNameId: '用户：',
    lab_changeColor: '正在换肤，请稍等...',
    lab_pinkType: '粉色主题',
    lab_greenType: '绿色主题',
    lab_blueType: '蓝色主题',
    lab_closeNow: '关闭当前',
    lab_closeAll: '关闭所有',
  /** ******************共通start****************** **/
    btn_search: '查询',
    btn_reset: '重置',
    btn_add: '新增',
    btn_delete: '删除',
    btn_edit: '编辑',
    btn_detail: '查看',
    btn_notes: '备注',
    btn_exportData: '数据导出',
    btn_exportTemplate: '导出模板',
    btn_importData: '成绩导入',
    btn_selectExcel: '选择文件',
    btn_import: '导入',
    btn_export: '导出',
    btn_moveUp: '上移',
    btn_moveDown: '下移',
    btn_upload: '点击上传',
    btn_cancel: '取消',
    btn_confirm: '确定',
    btn_allSelect: '全选',
    btn_updateRecord: '上传记录',
    lab_updateRecord: '是否将成绩上传至赛会记录',
    lab_updateCancel: '取消上传',
    lab_updateSuccess: '更新成功',
    lab_notUploaded: '未上传',
    lab_operation: '操作',
    lab_to: '至',
    lab_isDelete: '是否删除?',
    lab_prompt: '提示',
    lab_delSuccess: '删除成功!',
    lab_delCancel: '已取消删除',
    lab_modifySuccess: '保存成功!',
    pla_pleaseInput: '请输入',
    pla_pleaseSelect: '请选择',
    pla_pleaseUpload: '请上传',
    lab_pleaseSeletcDoc: '请选择上传文件',
    tip_upload1: '请上传jpg/jpeg/png文件',
    tip_upload2: '请上传pdf文件',
    tip_upload3: '请上传xlsx/xls文件',
    tip_upload4: '请上传mp4文件，建议不超过20M',
    tip_upload_imgUrl: '请上传jpg/jpeg/png文件，比例为11:5的图片显示效果最佳',
    tip_upload_img: '请上传jpg/jpeg/png文件，比例为2:5的图片显示效果最佳',
    lab_uploadSuccess: '上传成功',
    warning_uploadLimit: '选择的上传文件个数超出文件的最大限制个数',
    warning_network: '服务连接超时，请检查你的网络连接',
    warning_selectOneDelete: '请至少勾选一条数据进行删除!',
    warning_passwordRule: '密码要求: 字母和数字组合，6到16位，不允许特殊字符。',
    warning_video: '您的浏览器不支持 video 元素。',
    lab_notOnload: '账号信息失效，请重新登录',
    lab_openTenMax: '最多只能打开10个标签页，如要打开请先关闭',
    error_uploadErr: '上传失败',
    error_uploadVideoErr: '请上传mp4文件',
  /** ****************** 共通end ****************** **/

  /***************
  页面路径: 	线下赛
  页面中文名称: 	线下赛
  页面英文名称: 	offlineList
  ******************/
  lab_competeName: '赛事名称',
  lab_competeStatus: '状态',
  lab_sessions: '场次',
  lab_teamManage: '团队',
  lab_competeItem: '赛事项目',
  lab_enrollNum: '已报人次',
  lab_totalFee: '累计收费(元)',
  lab_enrollTime: '报名时间',
  lab_enrollTimeStart: '报名开始时间',
  lab_enrollTimeEnd: '报名结束时间',
  lab_raceTime: '比赛时间',
  lab_ageStandard: '年龄判断基准',
  lab_raceTimeStart: '比赛开始时间',
  lab_raceTimeEnd: '比赛结束时间',
  lab_singleFee: '单人单项费用(元)',
  lab_singleFee1: '单人单项费用',
  lab_singlePerFee: '单人费用(元)',
  lab_singlePerFee1: '单人费用',
  lab_creatTeam: '用户创建团队',
  lab_chargeMethod: '收费方式',
  lab_perPersonCharge: '按人收费',
  lab_chargePerItem: '按项目收费',
  lab_signUpAndChooseTeam: '报名选择团队',
  lab_signUpAndChooseTeamRequired: '必选',
  lab_signUpAndChooseTeamUnRequired: '非必选',
  lab_creatTeamPermit: '允许',
  lab_creatTeamForbid: '禁止',
  lab_teamEnrollLimit: '团队报名人数限制',
  lab_teamEnrollLowLimit: '团队报名人数下限',
  lab_teamEnrollUpLimit: '团队报名人数上限',
  lab_singleEnrollItemLimit: '单人报名项目上限',
  lab_competeImg: '赛事封面',
  lab_competeRule: '赛事规程',
  lab_downloadPDF: 'PDF下载',
  lab_competeItemName: '赛事项目名称',
  lab_enrollLimit: '报名上限',
  lab_enrollNums: '已报人数',
  lab_whiteList: '白名单',
  btn_addwhiteList: '添加',
  btn_downwhiteList: '下载',
  btn_whiteList: '白名单模板导出',
  btn_orderlistexpor: '秩序单导出',
  btn_resultexport: '成绩导出',
  btn_changewhiteList: '更换',
  btn_deletewhiteList: '删除',
  btn_addCompeteItem: '点击添加赛事项目',
  btn_modifyCompeteItem: '点击修改赛事项目',
  lab_certificateBg: '证书背景',
  lab_groupChatCode: '群聊二维码',
  lab_addCompeteItem: '添加赛事项目',
  lab_competeEvent: '比赛项',
  lab_competeGroup: '组别',
  lab_competeAgeGroup: '年龄段',
  lab_competeCategory: '赛事类别',
  btn_confirmToCompete: '确定更新到赛事',
  warning_teamEnrollLimit: '请输入团队报名人数限制',
  warning_teamEnrollLowLimit: '请输入团队报名人数下限',
  warning_teamEnrollUpLimit: '请输入团队报名人数上限',
  warning_teamEnrollLowUp: '团队报名人数下限不大于团队报名人数上限',
  warning_teamEnrollMin: '团队报名人数下限不小于1人',
  warning_enrollTime: '请选择报名时间',
  warning_raceTime: '请选择比赛时间',
  warning_ageStandard: '请选择年龄限制',
  warning_competeItem: '请至少添加一个赛事项目',
  warning_enrollLimit: '不可小于已报人数',
  warning_enrollNum: '已有报名人数的赛事项目不可删除!',
  warning_singleFee: '单人单项费用不能为0',
  warning_startTime: '比赛开始时间不可早于报名结束时间！',
  Offline_states: [
    {
      id: '',
      name: '请选择状态',
    }, {
      id: 0,
      name: '报名中',
    }, {
      id: 1,
      name: '比赛中',
    }, {
      id: 2,
      name: '已结束',
    }, {
      id: 3,
      name: '已上线',
    }, {
      id: 4,
      name: '已下线',
    }, {
      id: 5,
      name: '未上线',
    }, {
      id: 6,
      name: '已取消',
    }, {
      id: 7,
      name: '报名已截止',
    }, {
      id: 8,
      name: '未开始',
    }, {
      id: 9,
      name: '比赛中报名中',
    }
  ],
  Offline_statesNew: [
    {
      id: '',
      name: '请选择状态',
      disabled: false
    }, {
      id: 0,
      name: '报名中',
      disabled: true
    }, {
      id: 1,
      name: '比赛中',
      disabled: true
    }, {
      id: 2,
      name: '已结束',
      disabled: true
    }, {
      id: 3,
      name: '已上线',
      disabled: false
    }, {
      id: 4,
      name: '已下线',
      disabled: true
    }, {
      id: 5,
      name: '未上线',
      disabled: false
    }, {
      id: 6,
      name: '已取消',
      disabled: true
    }, {
      id: 7,
      name: '报名已截止',
      disabled: true
    }, {
      id: 8,
      name: '未开始',
      disabled: true
    }, {
      id: 9,
      name: '比赛中报名中',
      disabled: true
    }
  ],
  Offline_statesEdit: [
    {
      id: '',
      name: '请选择状态',
      disabled: false
    }, {
      id: 0,
      name: '报名中',
      disabled: true
    }, {
      id: 1,
      name: '比赛中',
      disabled: true
    }, {
      id: 2,
      name: '已结束',
      disabled: true
    }, {
      id: 3,
      name: '已上线',
      disabled: false
    }, {
      id: 4,
      name: '已下线',
      disabled: false
    }, {
      id: 5,
      name: '未上线',
      disabled: true
    }, {
      id: 6,
      name: '已取消',
      disabled: false
    }, {
      id: 7,
      name: '报名已截止',
      disabled: true
    }, {
      id: 8,
      name: '未开始',
      disabled: true
    }, {
      id: 9,
      name: '比赛中报名中',
      disabled: true
    }
  ],
  /***************
  页面路径: 	赛事项目列表
  页面中文名称: 	赛事项目列表
  页面英文名称: 	projectList
  ******************/
  //  同线下赛->赛事项目

  /***************
  页面路径: 	线下赛->场次管理
  页面中文名称: 	场次管理
  页面英文名称: 	sessionsList
  ******************/
  lab_venue: '场馆',
  lab_competeStartTime: '比赛时间',
  lab_sessionName: '场次名称',
  lab_detailLocation: '地址',
  lab_gm: '(GTM+8 北京，新加坡)',
  lab_order: '排序',
  warning_orderLow: '排序值大于0',

  /***************
   *   页面路径: 	线下赛->团队管理
  页面中文名称: 	团队管理
  页面英文名称: 	teamsList
  ******************/
  lab_teamName: '团队名称',
  lab_leaderPhone: '队长电话',
  lab_numberOfPeoplee: '人数',

  /***************
  页面路径: 	线下赛->选手列表
  页面中文名称: 	选手列表
  页面英文名称: 	playersList
  ******************/
  lab_name: '姓名',
  lab_gender: '性别',
  lab_delegation: '代表队',
  lab_weChat: '报名微信号',
  lab_enrollStatus: '状态',
  lab_certificateNum: '证件号',
  lab_certificateType: '证件类型',
  lab_age: '年龄',
  lab_birthday: '生日',
  lab_paidFee: '已缴费用(元)',
  lab_paidChargeMethod: '收费方式',
  lab_playersList: '选手列表',
  lab_delegationId: '代表队Id',
  Players_gender: [
    {
      id: '',
      name: '请选择性别',
    }, {
      id: 0,
      name: '女',
    }, {
      id: 1,
      name: '男',
    }
  ],
  Players_enrollStatus: [
    {
      id: '',
      name: '请选择状态',
    }, 
    {
      id: 0,
      name: '取消报名',
    }, {
      id: 1,
      name: '报名成功',
    }
  ],

  /***************
  页面路径: 	线下赛->选手列表->选手信息及成绩
  页面中文名称: 	选手信息及成绩
  页面英文名称: 	playerInfoList
  ******************/
  lab_phone: '手机号',
  lab_group_lane: '组/道',
  lab_groupRanking: '分组名次',
  lab_totalRanking: '总名次',
  lab_result: '成绩',
  lab_playerInfoList: '选手成绩列表',

  /***************
  页面路径: 	线下赛->赛事项目->选手分组管理
  页面中文名称: 	选手分组管理
  页面英文名称: 	groupsList
  ******************/
  lab_group: '分组',
  lab_historyBestRecord: '历史最好成绩',
  lab_swimLane: '泳道',
  lab_record: '成绩',
  lab_autoGroup: '自动分组',
  lab_groupNum: '每组比赛人数',
  lab_groupCount: '分组数',
  lab_groupsList: '选手分组列表',
  Groups_autogGroups: [
    {
      id: 1,
      name: '1',
    }, {
      id: 2,
      name: '2',
    }, {
      id: 3,
      name: '3',
    }, {
      id: 4,
      name: '4',
    }, {
      id: 5,
      name: '5',
    }, {
      id: 6,
      name: '6',
    }, {
      id: 7,
      name: '7',
    }, {
      id: 8,
      name: '8',
    }, {
      id: 9,
      name: '9',
    }, {
      id: 10,
      name: '10',
    },
  ],
  Groups_groups: [
    {
      id: 1,
      name: '1',
    }, {
      id: 2,
      name: '2',
    }, {
      id: 3,
      name: '3',
    }, {
      id: 4,
      name: '4',
    }, {
      id: 5,
      name: '5',
    }, {
      id: 6,
      name: '6',
    }, {
      id: 7,
      name: '7',
    }, {
      id: 8,
      name: '8',
    }, {
      id: '',
      name: '-',
    }, 
  ],

  /***************
  页面路径: 	赛事管理->赛事类别管理
  页面中文名称: 	赛事类别管理
  页面英文名称: 	categoryList
  ******************/
  lab_category: '类别',
  Category_status: [
    {
      id: '',
      name: '请选择状态',
    }, {
      id: 0,
      name: '禁用',
    }, {
      id: 1,
      name: '正常',
    }
  ],

  /***************
  页面路径: 	赛事管理->比赛项管理
  页面中文名称: 	比赛项管理
  页面英文名称: 	matchList
  ******************/
  lab_isRelay: '是否接力赛',
  lab_isNeedOther: '是否需要报名其他项目',
  lab_numLimit: '接力赛人数上限',
  lab_matchRelay: '是否为接力赛',
  warning_numLimitMin: '接力赛人数上限不小于2人',
  Match_matchs: [
    {
      id: '',
      name: '请选择是否为接力赛',
    }, {
      id: 0,
      name: '否',
    }, {
      id: 1,
      name: '是',
    }
  ],
  Match_others: [
    {
      id: '',
      name: '请选择是否需要报名其他项目',
    }, {
      id: 0,
      name: '否',
    }, {
      id: 1,
      name: '是',
    }
  ],

  /***************
  页面路径: 	赛事管理->组别管理
  页面中文名称: 	组别管理
  页面英文名称: 	groupList
  ******************/
  lab_genderLimit: '性别限制',
  Group_gender: [
    {
      id: '',
      name: '请选择性别',
    }, {
      id: 0,
      name: '女',
    }, {
      id: 1,
      name: '男',
    }, {
      id: 2,
      name: '不限',
    }, {
      id: 3,
      name: '等比例混合',
    }, {
      id: 4,
      name: '非等比例混合',
    }
  ],

  /***************
  页面路径: 	赛事管理->年龄段管理
  页面中文名称: 	年龄段管理
  页面英文名称: 	competeAgeGroupList
  ******************/
  lab_ageGroupLimit: '年龄限制',
  lab_ageGroupLimitStart: '请输入年龄下限',
  lab_ageGroupLimitEnd: '请输入年龄上限',
  warning_ageGroupLimit: '请选择年龄限制',
  warning_ageEnrollMin: '年龄不能小于0岁',
  warning_ageLatelyLimit: '请输入年龄下限',
  warning_ageEarlyLimit: '请输入年龄上限',
  warning_ageEnrollLowUp: '年龄上限不能小于年龄下限',
  warning_ageEnrollMax: '年龄最大可超过120岁',
  tip_ageDate: '可直接输入格式为yyyy-MM-dd的日期',

  /***************
  页面路径: 	赛会记录
  页面中文名称: 	赛会记录
  页面英文名称: 	meetingRecordList
  ******************/
  lab_displayNum: '显示名次数',

  /***************
  页面路径: 	赛会记录->赛会记录详情
  页面中文名称: 	赛会记录详情
  页面英文名称: 	meetingRecordDetail
  ******************/
  lab_searchfor: '搜索',
  lab_ranking: '名次',
  lab_searchforname: '姓名、赛事名称、证件号',
  lab_competeOrder: '编号',
  lab_playerName: '选手姓名',
  lab_meetingRecordDetail: '赛会记录详情',
  MeetingRecordDetail_idType: [
    {
      id: 0,
      name: '身份证',
    }, {
      id: 1,
      name: '护照',
    }, {
      id: 2,
      name: '港澳身份证',
    }, {
      id: 3,
      name: '台胞证',
    }
  ],

  /***************
  页面路径: 	其他->轮播图管理
  页面中文名称: 	轮播图管理
  页面英文名称: 	carouselMng
  ******************/
  lab_index: '序号',
  lab_pic: '图片',
  lab_jumpUrl: '跳转链接',
  lab_jumpAdd: '跳转地址',
  lab_jumpAddInput: '，最多可输入255个字符',
  lab_bannerStatus: '状态',
  CarouselMng_status: [
    {
      id: '',
      name: '请选择状态',
    }, {
      id: 0,
      name: '禁用',
    }, {
      id: 1,
      name: '正常',
    }
  ],
  CarouselMng_isJump: [
    {
      id: 0,
      name: '无',
    }, {
      id: 1,
      name: '有',
    }
  ],
  /***************
  页面路径: 	首页
  页面中文名称: 	首页
  页面英文名称: 	home
  ******************/
  lab_title: '标题',
  lab_readStatus: '状态',
  lab_messageTime: '时间',
  lab_number: '#',
  lab_more: '更多>>',
  lab_todayEnrollNum: '今日报名人次',
  lab_yesterdayEnrollNum: '昨日报名人次:',
  lab_todayVisitNum: '今日访问量',
  lab_yesterdayVisitNum: '昨日访问量:',
  lab_totalEnrollNum: '总报名人次',
  lab_totalVisitNum: '总访问量',
  lab_unreadMessages: '未读消息',

  /***************
  页面路径: 	我的消息
  页面中文名称: 	我的消息
  页面英文名称: 	message
  ******************/
  lab_myMessage: '我的消息',
  lab_messageType: '类型',
  lab_messageTitle: '标题',
  btn_read: '全部标记已读',
  lab_messageTimes: '消息时间',
  lab_messageTypeName: '消息类型',
  lab_yuan: '元',
  lab_fee: '缴纳费用',
  Message_status: [
    {
      id: '',
      name: '请选择状态',
    }, {
      id: 0,
      name: '未读',
    }, {
      id: 1,
      name: '已读',
    }
  ],
  Message_messageType: [
    {
      id: '',
      name: '请选择类型',
    }, {
      id: 0,
      name: '取消报名消息',
    }, {
      id: 1,
      name: '报名成功消息',
    }    
  ],

  /***************
  页面路径: 	账号管理
  页面中文名称: 	账号管理
  页面英文名称: 	accountMng
  ******************/
  lab_user: '使用者',
  lab_account: '账号',
  lab_password: '密码',
  lab_isStatus: '状态',
  lab_keyword: '使用者或账号',
  warning_passwordNotOK: '密码格式不正确',
  warning_accountNotOK: '账号仅包含字母、数字',
  AccountMng_status: [
    {
      id: '',
      name: '请选择状态',
    }, {
      id: 0,
      name: '正常',
    }, {
      id: 1,
      name: '禁用',
    }
  ],

  /***************
  页面路径: 	修改密码
  页面中文名称: 	修改密码
  页面英文名称: 	passwordMng
  ******************/
  lab_modifyPwd: '密码修改',
  lab_nowAccount: '当前账号',
  lab_oldPwd: '旧密码',
  lab_newPwd: '新密码',
  lab_comfirmPwd: '确认新密码',
  lab_changePwd: '确认修改',
  pla_pleaseInputAgain: '请再次输入新密码',
  lab_changePwdSuccess: '修改成功请重新登录',
  warning_passwordNotSame: '确认密码和新密码不一致',

  /***************
  页面路径: 	登录
  页面中文名称: 	登录
  页面英文名称: 	login
  ******************/
  lab_userName: '用户名',
  lab_login: '登录',
  lab_word: '美再晨信息管理系统',
  lab_conpanyName: '美再晨信息管理系统',
  warning_ban: '当前账号已被禁用，请联系超级管理员恢复!',
  lab_successLogin: '欢迎进入美再晨信息管理系统',

  /***************
  导出数据
  ******************/
  lab_dateRule: '(如比赛为2020年5月1日,请填写2020-05-01)',
  lab_resultRule1: '(如成绩5分00秒95,请填写5:00:950,毫秒最后一位必须是0)',
  lab_resultRule: '(必填项,如成绩5分00秒95,请填写5:00:950,毫秒最后一位必须是0)',
  lab_technicalPointRule: '(必填项,如专家分10.5,请填写10.5)',
  lab_notModify1: '导入时,除',
  lab_notModify2: '外,其他条目请勿修改！',
  lab_rankingRule: '(格式要求数字)',
  lab_star: '*',
  btn_startExport: '开始导出',
  
  /***************
  页头
  ******************/
  title_meetingRecordDetail: '赛会记录 > 赛会记录详情',
  title_eventsList: '线下赛 > 赛事项目',
  title_groupsList: '线下赛 > 赛事项目 > 选手分组管理',
  title_playersList: '线下赛 > 选手列表',
  title_sessionsList: '线下赛 > 场次管理',
  title_teamsList: '线下赛 > 团队管理',
  title_playerInfoList1: '线下赛 > 赛事项目 > 选手分组管理 > 选手信息及成绩',
  title_playerInfoList2: '线下赛 > 选手列表 > 选手信息及成绩',
  title_playerList: '线上赛 > 选手列表',
  title_playerVotes: '线上赛 > 选手列表 > 投票详情',
  title_competeFiles: '线上赛 > 选手列表 > 参赛文件',

  /***************
  页面路径: 	线上赛
  页面中文名称: 	线上赛
  页面英文名称: 	online
  ******************/
  lab_videoTimeLimit: '参赛作品时长限制(秒)',
  lab_videoTimeLimit1: '参赛作品时长限制',
  lab_videoTimeLowLimit: '参赛作品时长下限',
  lab_videoTimeUpLimit: '参赛作品时长上限',
  lab_competeLongPic: '赛事介绍长图',
  lab_voteLimit: '投票限制',
  lab_voteNum: '每日可投票数',
  lab_pointRule: '评分规则',
  lab_popularPoint: '人气分',
  lab_popularPoint1: '人气分:',
  lab_technicalPoint: '专家分',
  lab_technicalPoint1: '专家分:',
  lab_totalPoint: '总分',
  lab_totalPoint1: '总分:',
  lab_popularitySetting: '人气分设置',
  lab_voteRankMinimum: '票数排名最小值',
  lab_voteRankMaximum: '票数排名最大值',
  lab_votePoint: '得分',
  lab_addSetting: '添加设置',
  lab_videoUrl: '演示视频',
  lab_saveCancel: '已取消保存',
  lab_popularityCompete: '人气奖设置',
  lab_popularityNum: '人气排名前(名)',
  lab_popularityNum1: '人气排名前多少名',
  lab_itemAgeId: '年龄段限制',
  lab_itemGroupId: '组别限制',
  warning_settingDeleteWarning: '是否删除此选项?（删除后请检查设置！）',
  warning_videoTime: '参赛作品时长限制的最大范围为20~120秒',
  warning_videoTimeLowUp: '参赛作品时长下限不大于上限',
  warning_videoTimeMin: '参赛作品时长下限不小于20秒',
  warning_videoTimeMax: '参赛作品时长下限不大于120秒',
  warning_voteNum: '每日可投票数仅可输入1~20',
  warning_popularitySetting: '请添加人气分设置',
  warning_settingWrong: '人气分设置有遗漏',
  warning_votePoint: '不可大于人气分',
  warning_voteRank: '不可大于报名上限',
  warning_voteRankLow: '票数排名大于0',
  warning_voteRankMax: '不可小于票数排名最小值',
  warning_pointRange: '输入范围0~100.0',
  warning_pointOrder: '人气分设置中，有排名靠前但得分低的设置，请重新设置',
  warning_pointSettingRepeat: '人气分设置票数排名有重复，请重新设置',
  warning_pointSettingLack: '人气分设置票数排名有遗漏，请重新设置',
  warning_pointSetting: '人气分设置票数排名异常，请重新设置',
  warning_endTime: '比赛结束时间不可晚于报名结束时间！',
  warning_startTime1: '比赛开始时间不可早于报名开始时间！',
  pla_pleaseFillin: '请填写',
  Online_voteLimits: [
    {
      id: '',
      name: '请选择状态',
    }, {
      id: 0,
      name: '仅投一次',
    }, {
      id: 1,
      name: '每日可投',
    }
  ],

  /***************
  页面路径: 	线上赛->选手列表
  页面中文名称: 	选手列表
  页面英文名称: 	playerList
  ******************/
  btn_batchPass: '批量通过',
  btn_copyAddress: '点击复制',
  lab_isPass: '是否进行批量通过？',
  lab_isCancelEnroll: '确认取消该选手报名？',  
  lab_isOnlyRefund1: '确认是否给',
  lab_isOnlyRefund2: '选手进行退费？',
  lab_cancelPass: '已取消批量通过',
  lab_cancelOperation: '已取消操作',
  lab_successOperation: '操作成功！',
  lab_votes: '票数',
  lab_address: '收货地址',
  lab_file: '参赛文件',
  lab_cancelEnroll: '取消报名',
  lab_onlyRefund: '仅退费',
  lab_valueIsNull: '---',
  lab_addressee: '收件人',
  lab_contactInfo: '联系方式',
  lab_copyAddress: '邮寄信息',
  warning_selectOnePass: '请至少勾选一条数据进行操作!',
  Player_enrollStatus: [
    {
      id: '',
      name: '请选择状态',
    }, {
      id: 0,
      name: '已取消',
    }, {
      id: 1,
      name: '已报名',
    }, {
      id: 2,
      name: '待审核',
    }, {
      id: 3,
      name: '审核通过',
    }, {
      id: 4,
      name: '审核未通过',
    }
  ],

  /***************
  页面路径: 	线上赛->选手列表->投票详情
  页面中文名称: 	投票详情
  页面英文名称: 	playerVotes
  ******************/
  lab_votesTime: '投票时间',
  lab_votesTimeStart: '投票开始时间',
  lab_votesTimeEnd: '投票结束时间',
  lab_nickName: '昵称',
  lab_openId: 'OpenId',

  /***************
  页面路径: 	线上赛->选手列表->参赛文件
  页面中文名称: 	投票详情
  页面英文名称: 	competeFiles
  ******************/
  lab_cover: '封面',
  lab_cover1: '1.封面:',
  lab_competeVideo: '比赛视频',
  lab_competeVideo1: '2.比赛视频:',
  lab_adopt: '通过',
  lab_refuse: '拒绝',
}
